export default __webpack_public_path__ + "static/media/servicios_3.56e2fbd7.jpg";